<style>
.refund .vview-formitem {
    margin-bottom: 6px;
}
</style>
<template>
    <div
        :class="{
            refund:
                type == 'query' ||
                oldrefundStatus == 'REFUNDED' ||
                oldrefundStatus == 'NULLIFY',
        }"
    >
        <vForm
            :label-width="120"
            class="margin-20 clearfix refuned"
            :class="{ queryform: type == 'query' }"
            ref="refundform"
        >
            <vCol span="24">
                <vCol span="12">
                    <div
                        class="font-14 font-bold padding-bottom-10 b2ccolor-error"
                    >
                        {{
                            $t("erp.aftersales.refundorder", {
                                defaultValue: "退款单",
                            })
                        }}
                        <span
                            v-if="type == 'query'"
                            class="font-12 font-bold b2color-black"
                            >(
                            <span v-if="type == 'query'">{{
                                filterStatus(formData.refundStatus)
                            }}</span>
                            )</span
                        >
                    </div>
                </vCol>
                <vCol span="12">
                    <div class="pull-right margin-bottom-20">
                        <div
                            class="font-bold"
                            v-if="
                                type != 'query' && oldrefundStatus == 'NULLIFY'
                            "
                        >
                            {{ filterStatus(formData.refundStatus) }}
                        </div>
                        <vSelect
                            v-if="
                                type != 'query' && oldrefundStatus != 'NULLIFY'
                            "
                            v-model="formData.refundStatus"
                            style="width: 120px"
                        >
                            <vOption
                                value="NOREFUND"
                                v-show="oldrefundStatus == 'NOREFUND'"
                                >{{
                                    $t("erp.aftersales.norefund", {
                                        defaultValue: "未退款",
                                    })
                                }}</vOption
                            >
                            <vOption
                                value="REFUNDED"
                                v-show="oldrefundStatus != 'NULLIFY'"
                                >{{
                                    $t("erp.aftersales.refunded", {
                                        defaultValue: "已退款",
                                    })
                                }}</vOption
                            >
                            <vOption value="NULLIFY">{{
                                $t("erp.aftersales.nullify", {
                                    defaultValue: "已作废",
                                })
                            }}</vOption>
                        </vSelect>
                    </div>
                </vCol>
            </vCol>

            <vCol span="12">
                <vFormItem
                    :label="
                        $t('global.common.currency', { defaultValue: '币种' })
                    "
                    v-if="
                        type == 'query' ||
                        oldrefundStatus == 'REFUNDED' ||
                        oldrefundStatus == 'NULLIFY'
                    "
                >
                    <div class="font-bold height-32">
                        {{ formData.currency }}
                    </div>
                </vFormItem>
                <vFormItem
                    v-else
                    :label="
                        $t('global.common.currency', { defaultValue: '币种' })
                    "
                    :rules="required"
                    prop="currency"
                >
                    <vSelect v-model="formData.currency">
                        <vOption
                            v-for="(item, index) in currencies"
                            :key="index"
                            :value="item.value"
                            >{{ item.value }}</vOption
                        >
                    </vSelect>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem
                    :label="
                        $t('erp.aftersales.refundAt', {
                            defaultValue: '退款时间',
                        })
                    "
                    v-if="
                        type == 'query' ||
                        oldrefundStatus == 'REFUNDED' ||
                        oldrefundStatus == 'NULLIFY'
                    "
                >
                    <div class="font-bold height-32">
                        {{ formData.refundAt }}
                    </div>
                </vFormItem>
                <vFormItem
                    v-else
                    :label="
                        $t('erp.aftersales.refundAt', {
                            defaultValue: '退款时间',
                        })
                    "
                    :rules="required"
                    prop="refundAt"
                >
                    <vDatepicker
                        v-model="formData.refundAt"
                        format="yyyy-mm-dd HH:MM:SS"
                        style="width: 100%"
                    ></vDatepicker>
                </vFormItem>
            </vCol>
            <vCol span="24">
                <vTable
                    class="margin-bottom-20"
                    style="width: 100%"
                    :columns="columns"
                    :data="datalist"
                    size="small"
                    ref="table"
                    border
                >
                </vTable>
            </vCol>
            <vCol span="12">
                <vFormItem
                    :label="
                        $t('erp.aftersales.refundFreight', {
                            defaultValue: '退款运费',
                        })
                    "
                    v-if="
                        type == 'query' ||
                        oldrefundStatus == 'REFUNDED' ||
                        oldrefundStatus == 'NULLIFY'
                    "
                >
                    <div class="font-bold height-32">
                        {{ formData.refundFreight }}
                    </div>
                </vFormItem>
                <vFormItem
                    v-else
                    :label="
                        $t('erp.aftersales.refundFreight', {
                            defaultValue: '退款运费',
                        })
                    "
                    :rules="required"
                    prop="refundFreight"
                >
                    <vInput
                        v-model="formData.refundFreight"
                        style="width: 100%"
                    ></vInput>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem
                    :label="
                        $t('erp.aftersales.refundamount', {
                            defaultValue: '退款金额',
                        })
                    "
                >
                    <div class="font-bold height-32">{{ refundAmount }}</div>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem
                    :label="
                        $t('erp.aftersales.refundExplain', {
                            defaultValue: '退款原因',
                        })
                    "
                >
                    <div
                        class="font-bold height-32"
                        v-if="
                            type == 'query' ||
                            oldrefundStatus == 'REFUNDED' ||
                            oldrefundStatus == 'NULLIFY'
                        "
                    >
                        {{ formData.refundExplain }}
                    </div>
                    <vTextarea
                        v-else
                        v-model="formData.refundExplain"
                        style="width: 100%"
                        :placeholder="
                            $t('boss.aftersales.inputs_are_allowed', {
                                defaultValue: '最多可输入100个字',
                            })
                        "
                        maxlength="100"
                    ></vTextarea>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem
                    :label="
                        $t('fbb.costmanage.explain', { defaultValue: '说明' })
                    "
                >
                    <div
                        class="font-bold height-32"
                        v-if="
                            type == 'query' ||
                            oldrefundStatus == 'REFUNDED' ||
                            oldrefundStatus == 'NULLIFY'
                        "
                    >
                        {{ formData.remark }}
                    </div>
                    <vTextarea
                        v-else
                        v-model="formData.remark"
                        style="width: 100%"
                        :placeholder="
                            $t('boss.aftersales.inputs_are_allowed', {
                                defaultValue: '最多可输入100个字',
                            })
                        "
                        maxlength="100"
                    ></vTextarea>
                </vFormItem>
            </vCol>
        </vForm>
    </div>
</template>

<script>
export default {
    props: [
        "orderServiceRefund",
        "tabledata",
        "comtype",
        "indexid",
        "querytype",
    ],
    components: {},
    data() {
        return {
            datalist: [],
            type: this.$route.params.type,
            formData: {
                refundStatus: "NOREFUND",
                currency: "USD",
            },
            currencies: [
                { value: "USD" },
                { value: "CNY" },
                { value: "EUR" },
                { value: "GBP" },
                { value: "CAD" },
                { value: "JPY" },
                { value: "AUD" },
                { value: "MXN" },
            ],
            required: [
                {
                    required: true,
                    message: this.$t("global.common.required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            oldrefundStatus: "NOREFUND",
        };
    },
    created() {
        this.datalist = this.tabledata.concat();
        if (this.comtype == "query") {
            this.type = this.comtype;
        } else if (this.querytype == "query") {
            this.type = this.querytype;
        } else {
            this.type = this.type;
        }
        this.getdata();
    },
    watch: {
        orderServiceRefund: {
            deep: true,
            handler(val) {
                this.formData = { ...this.formData, ...val };

                if (this.tabledata) {
                    this.datalist = this.tabledata.concat();
                }

                if (!val.refundStatus) {
                    this.oldrefundStatus = "NOREFUND";
                } else {
                    this.oldrefundStatus = val.refundStatus;
                }
                if (!val.refundAt) {
                    this.getdata();
                }
            },
        },
    },
    computed: {
        refundAmount() {
            return (
                this.datalist.reduce((pre, cur, index, arrs) => {
                    return pre + parseFloat(cur.refundAmount || 0);
                }, 0) + parseFloat(this.formData.refundFreight || 0)
            );
        },
        columns() {
            let _this = this;
            return [
                {
                    title: "ERP SKU",
                    key: "erpSku",
                },
                {
                    title: "Seller SKU",
                    key: "sellerSku",
                },
                {
                    title: this.$t("erp.aftersales.buy_shipnum", {
                        defaultValue: "购买/已发数量",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.buyNum}/{row.shippingNum}
                            </div>
                        );
                    },
                },
                {
                    // title: "",
                    // key: 'refundAmount',
                    renderHeader: (h, params) => {
                        if (
                            _this.type == "query" ||
                            _this.oldrefundStatus == "REFUNDED" ||
                            _this.oldrefundStatus == "NULLIFY"
                        ) {
                            return h("div", [
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.refundamount", {
                                        defaultValue: "退款金额",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h("Icon", {
                                    props: {
                                        type: "ios-medical",
                                        color: "#ed3f14",
                                    },
                                    style: "margin-right:5px",
                                }),
                                h(
                                    "strong",
                                    this.$t("erp.aftersales.refundamount", {
                                        defaultValue: "退款金额",
                                    })
                                ),
                            ]);
                        }
                    },
                    render(h, { row, index }) {
                        if (
                            _this.type == "query" ||
                            _this.oldrefundStatus == "REFUNDED" ||
                            _this.oldrefundStatus == "NULLIFY"
                        ) {
                            return <div>{row.refundAmount}</div>;
                        } else {
                            return h("vInput", {
                                props: {
                                    size: "small",
                                    value: row.refundAmount,
                                },
                                on: {
                                    input: (event) => {
                                        row.refundAmount = event;
                                        // _this.datalist[index] = row
                                        _this.$set(
                                            _this.datalist[index],
                                            "refundAmount",
                                            event
                                        );
                                    },
                                },
                            });
                        }
                    },
                },
            ];
        },
    },
    methods: {
        getdata() {
            let gmttome = this.$moment()
                .tz("GMT")
                .format("YYYY-MM-DD HH:mm:ss");
            this.formData.refundAt = gmttome;
        },
        async validate() {
            // console.log(123123)
            const bool1 = await this.$refs["refundform"].validate();
            // console.log(bool1)
            if (!bool1) {
                this.$VMessage.warning(
                    this.$t("global.form.require", {
                        defaultValue: "请填写必填项",
                    })
                );
            }
            return bool1;
        },
        filterStatus(val) {
            let status;
            switch (val) {
                case "NOREFUND":
                    status = this.$t("erp.aftersales.norefund", {
                        defaultValue: "未退款",
                    });
                    break;
                case "REFUNDED":
                    status = this.$t("erp.aftersales.refunded", {
                        defaultValue: "已退款",
                    });
                    break;
                case "NULLIFY":
                    status = this.$t("erp.aftersales.nullify", {
                        defaultValue: "已作废",
                    });
                    break;
            }
            return status;
        },
    },
};
</script>
